import React from 'react';
import { Box, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

/** Red-and-white bar. Kept on every page. */
export const CandyCane: React.FC = () => (
  <Box
    aria-hidden
    sx={{
      height: 16,
      backgroundImage: 'repeating-linear-gradient(45deg, #c4313b 0 14px, #fff 14px 28px)',
    }}
  />
);

const SiteFooter: React.FC = () => (
  <Box component="footer" sx={{ mt: 'auto' }}>
    <Box sx={{ py: 2.5, textAlign: 'center', color: 'text.secondary', fontSize: '0.95rem' }}>
      Made with ♥ by Luke
      <Box component="span" sx={{ mx: 1, color: '#c4b8a8' }}>·</Box>
      <Link component={RouterLink} to="/privacy" color="inherit" underline="hover">Privacy</Link>
      <Box component="span" sx={{ mx: 1, color: '#c4b8a8' }}>·</Box>
      <Link component={RouterLink} to="/terms" color="inherit" underline="hover">Terms</Link>
    </Box>
    <CandyCane />
  </Box>
);

export default SiteFooter;
